import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseAddStaffUserMutationResponse } from "../utils/types";

const useUpdateStaff = (
  staffId: string | undefined
): IUseAddStaffUserMutationResponse => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const { id, ...payload } = data;
      const response = await AXIOS_RESERVATION.put(
        `v1/staff/${staffId || id}`,
        payload,
        {
          headers: {
            pageName: "staff",
          },
        }
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["staff"] });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: ["staff"] });
    },
  });
};

export default useUpdateStaff;
